module.exports = __webpack_public_path__ + "static/media/HydraulicEnergyPotentialWorld.c7b825a2.gif";